import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import AssetsTable from './assetsTable';

const Assets = () => {
  const [activeTab, setActiveTab] = useState<'Installed Software' | 'Software Deployment'>('Installed Software');
  const navigate = useNavigate();

  const deploymentNavigation = () => {
    navigate('/SoftwareDeployment');
  };

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#000)] flex-1">
        <Header title="Software Inventory" dropdown={2} />

        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
            {['Installed Software', 'Software Deployment'].map((tab) => (
              <button
                key={tab}
                onClick={() => {
                  setActiveTab(tab as 'Installed Software' | 'Software Deployment');
                  if (tab === 'Software Deployment') {
                    deploymentNavigation();
                  }
                }}
                style={{
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                  borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                {tab}
              </button>
            ))}
          </div>
          <AssetsTable />
        </Card>
      </div>
    </div>
  );
};

export default Assets;
